import { Logger } from './logger';
export const Log = Logger.getInstance();
